import { useState, useCallback } from "react";
import { NavLinkProps, useNavigate, NavLink } from "react-router-dom";
import { useDirty } from "../contexts/DirtyContext";
import { ConfirmDirtyNavigationDialog } from "../components/modals/ConfirmDirtyNavigationDialog";

export function DirtyAwareNavLink({ to, children, ...props }: NavLinkProps) {
  const [dirty] = useDirty();
  const [confirmDirtyNav, setConfirmDirtyNav] = useState(false);
  
  const navigate = useNavigate();

  const guard = useCallback((event: React.MouseEvent) => {
    if (!dirty) return;

    event.preventDefault();
    setConfirmDirtyNav(true);
  }, [dirty]);

  const handleConfirmDirtyNav = useCallback((confirmed: boolean) => {
    setConfirmDirtyNav(false);

    if (!confirmed) return;

    navigate(to);
  }, [navigate, to]);

  return (
    <>
      <ConfirmDirtyNavigationDialog isOpen={confirmDirtyNav} onConfirm={handleConfirmDirtyNav} />
      <NavLink onClick={guard} to={to} {...props}>{children}</NavLink>
    </>
  );
}